export function checkIfExpired(date: string, fromCommonLib?: boolean) {
    if (fromCommonLib && date === '0001-01-01T00:00:00')
        return false;
    return new Date(date) < new Date();
}

export type UserAttributes = {
    email: string;
    id: number;
    name: string | undefined;
    fromCommonLib: boolean | undefined;
    policyId: number;
    role: string;
    scope: string | undefined;
    system: string;
    dateTimeExpire: string;
    isExpired: boolean;
};
